import { useEffect, useCallback, useState } from 'react';
import PostsProfile from 'containers/PostsProfile';
import fetchApi from 'hooks/fetchApi';
import API_NAME from 'services/api';

// Own
import { Iprofile } from './Types';
import { PostsContainer } from './Profile.styles';

const Profile = ({ id }: Iprofile) => {
  return (
    <PostsContainer>
      <PostsProfile id={id} />
    </PostsContainer>
  );
};

export default Profile;
